// # name       channels    description
// # 1          1           Bilevel (1-bit pixels, pure black and white). No shades of grey; very small file size.
// # L          1           Greyscale (8-bit pixels, black and white). Often used for masks and depth maps.
// # LA         2           Greyscale with Alpha (2x8-bit pixels). L channel + Transparency.

// # P          1           Palette (8-bit pixels). Maps to a color look-up table. Standard for GIFs and optimized PNGs.
// # PA         2           Palette with Alpha (2x8-bit pixels). Palette mapping + Transparency.

// # RGB        3           True Color (3x8-bit pixels). The standard mode for most web and AI images (Red, Green, Blue).
// # RGBA       4           True Color with Transparency (4x8-bit pixels). Includes an Alpha channel for masks or "holes."
// # RGBX       3           True Color with Padding (4x8-bit pixels). RGB stored in 32-bits for memory alignment.
// # RGBa       4           Premultiplied Alpha (4x8-bit pixels). Color channels are pre-multiplied by the alpha value.

// # CMYK       4           Color Separation (4x8-bit pixels). Cyan, Magenta, Yellow, Black. Primarily used for professional printing.
// # YCbCr      3           Video Color Format (3x8-bit pixels). Luminance (Y) and two chrominance components (Cb, Cr).
// # LAB        3           CIE LAB (3x8-bit pixels). A perceptually uniform color space representing Lightness (L) and two color axes (A, B).
// # HSV        3           Hue, Saturation, Value (3x8-bit pixels). Useful for artistic adjustments like changing a specific color's "vibrancy."

// # I          1           Integer Greyscale (32-bit signed integer pixels). High-precision greyscale, often used in scientific imaging.
// # I;16       1           16-bit Integer Greyscale (16-bit unsigned). Common in medical imaging (DICOM) and RAW photos.
// # F          1           Floating Point Greyscale (32-bit floating point pixels). Standard for raw Latent tensors before they are converted to images.

//for GENERATED images in OUTPUT always = DEFAULT before generation and actual mode after generation
export enum ENUM__image_color_mode {
  DEFAULT = 'DEFAULT',
  ONE = '1',

  L = 'L',
  LA = 'LA',

  P = 'P',
  PA = 'PA',

  RGB = 'RGB',
  RGBA = 'RGBA',
  RGBX = 'RGBX',
  RGBa = 'RGBa',

  CMYK = 'CMYK',
  YCbCr = 'YCbCr',
  LAB = 'LAB',
  HSV = 'HSV',

  I = 'I',
  I16 = 'I;16',
  F = 'F',
}

export namespace ENUM_UTILS_image_color_mode {
  export function get_valid_db_values(): ENUM__image_color_mode[] {
    let out = Object.values(ENUM__image_color_mode);

    out = out.filter(item => item != ENUM__image_color_mode.DEFAULT);

    return out;
  }
}
